import React from "react";

// import CheckIcon from "@/public/images/summer-promo-smartico/check-icon.svg";
// import XIcon from "@/public/images/summer-promo-smartico/x-icon.svg";
import { getSmarticoRaffles, useSmarticoRaffleAdditionalDrawData, useSmarticoRaffleDrawById } from "../../store";
import { getCookie } from "../../../../../../helpers/cookies";
import CardLabelStatus from "../../../../../(custom-header)/spring-daily-raffle/components/CardLabelStatus";
import { useTimer } from "../../../../../hooks/useTimer";
import { useAppDispatch } from "../../../../hooks";
import useSmartico from "../../../../../hooks/useSmartico";
import ArrowRightIcon from "@/app/shared-components/icons/ArrowRightIcon";
import ChevronsRightIcon from "@/app/shared-components/icons/ChevronsRightIcon";
import { useRaffleContext } from "../../../../../(custom-header)/spring-daily-raffle/context";
import { TabKey } from "./AllPrizesModal/utils/types";

interface IGeneralRaffleCardProps {
  drawId?: number;
  dataNotLoaded?: boolean;
}

const TicketIcon = () => {
  return (
    <img
      src={"/images/summer-promo-smartico/ticket2.png"}
      alt="ticket"
      width={24}
      height={24}
      className="w-5 lg:w-6 shrink-0"
    />
  );
};

const SharedHtml = ({ drawId, dataNotLoaded = false }: { drawId: number; dataNotLoaded: boolean }) => {
  const drawAdditionalData = useSmarticoRaffleAdditionalDrawData(drawId);
  const draw = useSmarticoRaffleDrawById(drawId);

  const isAuth = getCookie("BotB.Authenticated") === "true";
  return (
    <>
      <div
        className={`absolute top-0 left-0 flex min-h-6 justify-center items-center gap-2.5 px-3 py-0.5 rounded-tl-md rounded-br-md bg-blue-1`}>
        <span
          className={`text-[11px] font-semibold leading-4 tracking-[0.44px] ${
            draw.is_grand ? "text-orange-1" : "text-gray-1"
          } ${dataNotLoaded ? "!opacity-50 blur-[6px]" : ""}`}>
          {dataNotLoaded ? "" : drawAdditionalData.badge}
        </span>
      </div>

      <div className={"flex flex-col gap-1"}>
        <h2
          className={`text-white font-bold lg:text-2xl lg:leading-[34px] lg:tracking-[0.24px] ${
            isAuth ? "text-16px leading-6 tracking-[0.16px]" : "text-lg leading-[26px] tracking-[0.18px]"
          } ${dataNotLoaded ? "!opacity-50 blur-[6px]" : ""}`}>
          {dataNotLoaded ? "4x 40.000 lei" : drawAdditionalData.title}
        </h2>
        <p
          className={`text-gray-2 lg:text-16px lg:font-medium lg:leading-6 lg:tracking-[0.16px] lg:min-h-12 ${
            isAuth
              ? "text-xs font-medium leading-[18px] tracking-[0.12px] min-h-9"
              : "text-sm font-medium leading-5 tracking-[0.14px] min-h-10"
          } ${dataNotLoaded ? "!opacity-50 blur-[6px]" : ""}`}>
          {dataNotLoaded ? "Premii cash, bonusuri, speciale și rotiri gratuite" : drawAdditionalData.description}
        </p>
      </div>
    </>
  );
};

const GeneralRaffleCard = ({ drawId, dataNotLoaded }: IGeneralRaffleCardProps) => {
  const { viewAllPrizes } = useRaffleContext();
  const dispatch = useAppDispatch();
  const api = useSmartico();
  const isAuth = getCookie("BotB.Authenticated") === "true";
  const raffleDraw = useSmarticoRaffleDrawById(drawId);
  const timer = useTimer(
    String(drawId),
    raffleDraw.execution_ts,
    {
      Finish: () => {
        dispatch(getSmarticoRaffles(api));
      },
    },
    "millisecond"
  );
  const drawAdditionalData = useSmarticoRaffleAdditionalDrawData(drawId);
  const daysCount = timer.days?.replace(/^0+/, "") || "0";
  const daysLabel = `${daysCount} ${Number(daysCount) === 1 ? "Day" : "Days"}`;

  return (
    <>
      <div
        className={
          "w-full h-full flex flex-col bg-white shadow-[0_1.5px_8px_0_rgba(0,0,0,0.20)] rounded-lg border border-[#C3C3C3]"
        }>
        <div className={"w-full relative"}>
          {!dataNotLoaded && <CardLabelStatus label={drawAdditionalData.badge} className={"absolute left-2 top-2"} />}

          <img
            src={
              dataNotLoaded
                ? "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                : drawAdditionalData.image
            }
            alt={"alt"}
            width={442}
            height={152}
            className="w-full aspect-[442/152] rounded-t-lg"
          />
        </div>

        <div
          className={`flex min-h-6 lg:min-h-8 justify-center items-center gap-1 self-stretch bg-black -mx-px font-jost text-xs font-semibold leading-4 lg:text-base lg:leading-[22px] ${dataNotLoaded ? "!opacity-50 blur-[6px]" : ""}`}>
          <div className={"text-white font-normal"}>Next Draw in:</div>
          <div className={`text-primary text-center font-semibold flex gap-[3px]`}>
            {timer.isPastADay ? (
              <>{dataNotLoaded ? "00 Days" : raffleDraw.execution_ts && daysLabel}</>
            ) : (
              <>
                <span className={"min-w-3.5 lg:min-w-5.5 inline-flex justify-end text-right"}>
                  {dataNotLoaded ? "00" : raffleDraw.execution_ts && timer.hours}h
                </span>
                <span className={"text-[#BCBCC0] font-semibold"}>:</span>
                <span className={"min-w-3.5 lg:min-w-5.5 inline-flex justify-end text-right"}>
                  {dataNotLoaded ? "00" : raffleDraw.execution_ts && timer.minutes}m
                </span>
                <span>:</span>
                <span>
                  <span className={"min-w-4 lg:min-w-5.5 inline-flex"}>
                    {dataNotLoaded ? "00" : raffleDraw.execution_ts && timer.seconds}
                  </span>
                  <span className={"min-w-3 lg:min-w-4 inline-flex text-[9px] lg:text-[12px] leading-none"}>
                    {dataNotLoaded
                      ? "00"
                      : raffleDraw.execution_ts &&
                        Math.floor(timer.milliseconds / 10)
                          .toString()
                          .padStart(2, "0")}
                  </span>
                </span>
              </>
            )}
          </div>
        </div>

        <div
          className={
            "flex flex-col items-start gap-6 self-stretch bg-white p-3 lg:p-4 rounded-[0_0_8px_8px] h-full justify-between"
          }>
          <div className={"flex flex-col gap-1 lg:gap-2"}>
            <div
              className={`font-jost text-lg font-bold leading-6 lg:text-[22px] lg:leading-7 bg-gradient-botb bg-clip-text [-webkit-background-clip:text] [-webkit-text-fill-color:transparent] ${dataNotLoaded ? "!opacity-50 blur-[6px]" : ""}`}>
              {dataNotLoaded ? "What will you win tonight?" : drawAdditionalData.title}
            </div>
            <div
              className={`min-h-10 self-stretch text-[#696971] font-jost text-sm font-medium leading-5 lg:text-base lg:leading-[22px] ${dataNotLoaded ? "!opacity-50 blur-[6px]" : ""}`}>
              {dataNotLoaded
                ? "Every day at 6PM, 6,000 prizes drop, from £1,000 tax-free cash to competition tickets and game credit."
                : drawAdditionalData.description}
              {/* "Every day at 9PM, 4,000 prizes drop, from iPhone 17s & cash to tickets & game credit" */}
            </div>
          </div>

          {!isAuth && (
            <div className={"flex items-center gap-4"}>
              <div className="flex items-center gap-2">
                <img
                  src="/assets/images/christmas-raffle/gift-card.png"
                  alt="gift"
                  className="size-8 lg:size-12 shrink-0"
                />

                <div className={"flex flex-col gap-1"}>
                  <button
                    onClick={() => viewAllPrizes(raffleDraw.is_grand ? TabKey.PREMII_INSTANT : TabKey.MAREA_EXTRAGERE)}
                    className={"text-primary font-jost text-xs font-medium leading-4 flex items-center gap-0.5"}>
                    <span>View Prizes</span>
                    <ArrowRightIcon className={"size-3 shrink-0 "} />
                  </button>
                  <div
                    className={`text-[#28282B] font-jost text-base font-bold leading-[22px] ${dataNotLoaded ? "!opacity-50 blur-[6px]" : ""}`}>
                    {dataNotLoaded ? "£17,000+" : drawAdditionalData.prizesText}
                    {/* {dataNotLoaded ? "£10,000+" : drawAdditionalData.prizesText} */}
                  </div>
                </div>
              </div>

              <div className="w-px h-10 bg-black/8" />

              <div className="flex items-center gap-2">
                <img
                  src="/assets/images/christmas-raffle/trophy-card.png"
                  alt="gift"
                  className="size-8 lg:size-12 shrink-0"
                />

                <div className={"flex flex-col gap-1"}>
                  <span className={"text-[#696971] font-jost text-xs font-medium leading-4 flex items-center gap-0.5"}>
                    <span className={`${dataNotLoaded ? "!opacity-50 blur-[6px]" : ""}`}>
                      {dataNotLoaded ? "label" : drawAdditionalData.winnersLabel}
                    </span>
                  </span>
                  <div
                    className={`text-[#28282B] font-jost text-base font-bold leading-[22px] ${dataNotLoaded ? "!opacity-50 blur-[6px]" : ""}`}>
                    {dataNotLoaded ? "6,000" : drawAdditionalData.winnersText}
                    {/* {dataNotLoaded ? "£10,000+" : drawAdditionalData.winnersText} */}
                  </div>
                </div>
              </div>
            </div>
          )}

          {isAuth && (
            <div className="flex flex-col items-start gap-6 self-stretch">
              <div
                className={
                  "flex items-center gap-1 text-[#4C4C52] font-jost text-sm font-normal leading-5 lg:text-base lg:leading-[22px]"
                }>
                <img
                  src={"/assets/images/christmas-raffle/ticket-icon.svg"}
                  alt="ticket"
                  width={20}
                  height={20}
                  className="size-5 lg:size-6 shrink-0"
                />
                <span>{drawAdditionalData.ticketsText}</span>
                <span className={"text-primary font-semibold"}>{raffleDraw.my_tickets_count}</span>
              </div>
              <button
                onClick={() => {
                  viewAllPrizes(TabKey.PREMII_ZILNIC);
                }}
                className="theme-btn theme-btn-primary theme-btn-xs lg:theme-btn-md min-w-[188px] lg:min-w-[221px] uppercase">
                ADD MORE DRAW TICKETS
                <ChevronsRightIcon className={"size-4 shrink-0"} variant={3} />
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default GeneralRaffleCard;
